import { JsonObject, JsonProperty } from 'json2typescript';
import { OperativePortfolioResponseInterface } from '../interfaces/portfolio.interface';

@JsonObject('OperativePortfolioResponseModel')
export class OperativePortfolioResponseModel
  implements OperativePortfolioResponseInterface
{
  @JsonProperty('AnalysisDate', String, true)
  analysisDate: string = undefined;

  @JsonProperty('Alias', String, true)
  alias: string = undefined;

  @JsonProperty('Currency', String, true)
  currency: string = undefined;

  @JsonProperty('Valuation', Number, true)
  valuation: number = undefined;

  @JsonProperty('Type', String, true)
  type: string = undefined;

  @JsonProperty('ModelPortfolioCode', String, true)
  modelPortfolioCode: string = undefined;

  @JsonProperty('ModelPortfolioName', String, true)
  modelPortfolioName: string = undefined;

  @JsonProperty('PortfolioCode', String, true)
  portfolioCode: string = undefined;

  @JsonProperty('ServiceModelCode', String, true)
  serviceModelCode: string = undefined;

  @JsonProperty('ProfitLoss', Number, true)
  profitLoss: number = undefined;

  @JsonProperty('ProfitLossPercent', Number, true)
  profitLossPercent: number = undefined;

  @JsonProperty('PortfolioCodeView', String, true)
  portfolioCodeView: string = undefined;

  @JsonProperty('ServiceModelName', String, true)
  serviceModelName: string = undefined;
}
